import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  scrollToSecureFlow(event: Event): void {
    event.preventDefault();
    const section = document.getElementById('secure-flow');
    if (!section) {
      return;
    }

    const headerOffset = 73;
    // Scroll a bit further into the section so the content fits below the header
    const extraScroll = 48;
    const top =
      section.getBoundingClientRect().top +
      window.scrollY -
      headerOffset +
      extraScroll;

    window.scrollTo({ top, behavior: 'smooth' });
  }
}
